import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import PropTypes from "prop-types";
const JTCGeneralCarousel = (props) => {
  const { content, maxItemsxl, maxItemslg, maxItemsmd, maxItemsxs } = props;

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 1200 },
      items: maxItemsxl,
      partialVisibilityGutter: 30,
    },
    desktop: {
      breakpoint: { max: 1200, min: 768 },
      items: maxItemslg,
      partialVisibilityGutter: 30,
    },
    smallDesktop: {
      breakpoint: { max: 768, min: 576 },
      items: maxItemsmd,
    },
    tablet: {
      breakpoint: { max: 576, min: 0 },
      items: maxItemsxs,
    },

    // xs: 0,
    // sm: 576,
    // md: 768,
    // lg: 992,
    // xl: 1200,
    // xxl: 1400,
  };

  return (
    <Carousel
      swipeable={false}
      draggable={false}
      showDots={false}
      autoPlay={false}
      responsive={responsive}
      infinite={false}
      customTransition="all .3"
      transitionDuration={100}
      containerClass="carousel-container"
      dotListClass="custom-dot-list-style"
      itemClass="carousel-item-padding-2-px"
      arrows={true}
    >
      {content}
    </Carousel>
  );
};
export default JTCGeneralCarousel;
JTCGeneralCarousel.defaultProps = {
  maxItemsxl: 4,
  maxItemslg: 4,
  maxItemsmd: 3,
  maxItemsxs: 2,
};
